<template>
  <v-card class="secondary" height="100%">
    <v-form ref="form">
      <v-card-title class="font-weight-medium secondary--text primary">
        {{ edit ? `Edit Department` : "Add Department" }}
        <v-spacer></v-spacer>
        <v-btn small icon @click="$emit('closeDialog')">
          <v-icon small color="secondary">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-5">
        <v-row>
          <v-col cols="6"
            ><v-text-field
              v-model.trim="form.name"
              label="Name*"
              outlined
              dense
              :rules="[rules.required]"
              hide-details="auto"
          /></v-col>
          <v-col cols="6"
            ><v-text-field
              v-model.trim="form.code"
              label="Code*"
              outlined
              dense
              :rules="[rules.required]"
              @input="form.code = form.code.toUpperCase()"
              hide-details="auto"
          /></v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="pt-0 mb-3 mx-2">
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="save">{{
          edit ? "Update" : "Save"
        }}</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>
import { rules } from "@/helpers/rules";

export default {
  props: {
    department: {
      type: Object,
      default: () => {},
    },
    edit: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {},
  data() {
    return {
      rules,
      form: {},
    };
  },
  computed: {},
  created() {
    this.init();
  },
  methods: {
    async init() {
      if (this.edit) {
        this.form = { ...this.department };
      }
    },

    save() {
      if (!this.$refs.form.validate()) return;

      if (this.edit) {
        this.$emit("update", this.form);
      } else {
        this.form.active = true;
        this.$emit("create", this.form);
      }
    },
  },
};
</script>

<style scoped></style>
